export class PremissasOrcPed {
  limiteRepasse: number = 0;
  inscricaoEstadualObg: boolean = false;
  podeUsarMultiFormaPagamento: boolean = false;
  comprovanteObrigatorio: boolean = false;
  pIntegVerVlServico: boolean = false;
  ativarVoucher: boolean = false;
  confirmarSemValidar: boolean = false;
  pUsarAcrescimo: boolean = false;
  usarFormulaRepasseCif: boolean = false;
  descClienteSobreporVendedor: boolean = false;
  calcCondPagNoFinal: boolean = false;
  pVendEditarFrete: boolean = false;
  podeAlterarValorFinal: boolean = false;
  usarTbFrete: boolean = false;
  pFreteManualAvulso: boolean = false;
  pFreteAdicionarServico: boolean = false;
  pFreteAdicionarSeguro: boolean = false;
  pUsarValorProjeto: boolean = false;
  usarQuestionarioEntrega: boolean = false;
  camposQuestionariosObrigatorio: boolean = false;
  mostrarValores: boolean = false;
  descontoPadrao: boolean = false;
  freteAutomatico: boolean = false;
  regraCalculos: number = 0;
  usarServicoEntrega: boolean = false;
  usarSeguro: boolean = false;
  cadastrarEnderecoEntrega: boolean = false;
  txVendaDireta: TxVendaDireta = { cif: 0, fob: 0};
  regraValidacaoKitPersonalizado: number = 0;
  telhadoNaCalculadora: boolean = false;
  pOcultarColunaDescricaoFileiras: boolean = false;
  msgEnderecoAdicional: string;
  pUsarEstoqueMinimo: boolean = false;
  pBloqPedidoSemEstoqueDisp: boolean = false;
  pCentroDistribuicao: boolean = false;
  pDispEstoque: boolean = false;
  kitProntoFrete: boolean = false;
  naoCalcularFrete: boolean = false;
  kitProntoDesconto: boolean = false;
  naoCalcularDesconto: boolean = false;
  usarCombInvStrCon: boolean = false;
  usarPrecoAvulso: boolean = false;
  calcValorFinalSugestao: boolean = false;
  removerItemSugEdicao: boolean = false;
  adProdKitPronto: boolean = false;
  pInteVerVlServico: boolean = false;
  adicionarVariosKitPronto: boolean = false;
  textoFibrometal: string = '';
  mostrarCodErp: boolean = false;
  mostrarObsNoItem: boolean = false;
  multiFornecedores: boolean = false;
  vendaProgramada: boolean = false;
  estoqueUnicoLote: boolean = false;
  modulosAtivos: number[] = [];
  integradorPodeAnexar: boolean = false;
  bloquearTipoFreteVendaDireta: boolean = false;
  pMultiFornecedor: boolean = false;
}

export class TxVendaDireta {
  cif: number;
  fob: number;
}
